import { numWordForm } from '@frontend/jetlend-core/src/utils/langUtils';
import ProgressBar from '@frontend/jetlend-web-ui/src/ui/ProgressBar/ProgressBar';
import React from 'react';
import { formatPercent } from '@frontend/jetlend-core/src/formatters/formatUtils';
import { getEstimatedMinutes } from '@app/features/academy/academy.helper';

import styles from '../CoursesItemCard.module.scss';

interface IProps {
    /**
     * Прогресс курса
     */
    passedProgress: number;
    /**
     * Пройденной количество блоков
     */
    passedBlocksCount: number;
    /**
     * Пройденное время
     */
    estimateTime: number;
}

/**
 * Компонент с информацией, о том, что курс в процессе прохождения
 * Отображается информация о прогрессе курса
 */
const ActiveCourseCardFooter:React.FC<IProps> = props => {
    const {
        passedProgress,
        passedBlocksCount,
        estimateTime,
    } = props;

    return (
        <>
            <ProgressBar
                darkGrey
                hideLabel
                type="success"
                size="small"
                progress={passedProgress}
            />
            <div className={styles['progress-block']}>
                <span>Пройдено {numWordForm(passedBlocksCount, 'blocks')} ({getEstimatedMinutes(estimateTime)})</span>
                <span>{formatPercent(passedProgress)}</span>
            </div>
        </>
    );
};

export default ActiveCourseCardFooter;